export default "__VITE_ASSET__BUYHFYH3__"